// @flow
import Resource from 'speed-js-core/src/api/NestedResource';

export default class SiteEquipmentAccessResource extends Resource {
    basePath: string = 'sites/sites/{parent}/equipment-access/';

    objectPath: string = 'sites/sites/{parent}/equipment-access/{ident}/';
}
